import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import { CustomerNotesResponseDataSchema, DataResponseWithPagination } from "schema"
import { z } from "zod"

type Response = DataResponseWithPagination<z.infer<typeof CustomerNotesResponseDataSchema>>

type Props = {
  customerId: string
  page?: number
  total?: number
  query?: string
  employeeId?: string
}

export const customerNotesQuery = (props: Props) =>
  queryOptions({
    queryKey: ["customer-notes", props],
    queryFn: async () => {
      const { customerId, page = 1, total = 20, query, employeeId } = props

      const response = await axios.get<Response>(`/customers/${customerId}/notes`, {
        params: { page, total, query: query || undefined, employeeId: employeeId || undefined },
      })
      return response.data
    },
  })

export function getCustomerNotesQueryKey(customerId: string) {
  return ["customer-notes", customerId]
}
